import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './FAQ.module.css';

function FAQ() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(0);
  const faqs = [
    { question: t('faq.q1'), answer: t('faq.a1') },
    { question: t('faq.q2'), answer: t('faq.a2') },
    { question: t('faq.q3'), answer: t('faq.a3') },
  ];

  return (
    <section id="faq" className={styles.section}>
      <h2 className={styles.heading}>{t('faq.heading')}</h2>
      <div className={styles.list}>
        {faqs.map((faq, i) => (
          <div
            key={i}
            className={`${styles.item} ${openIndex === i ? styles.itemOpen : ''}`}
          >
            <button
              type="button"
              className={styles.trigger}
              onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
              aria-expanded={openIndex === i}
            >
              <span className={styles.question}>{faq.question}</span>
              <span className={styles.icon}>{openIndex === i ? '−' : '+'}</span>
            </button>
            {openIndex === i && (
              <div className={styles.answer}>{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;
